import Box from "ds/components/Box";
import Typography from "ds/components/Typography";
import Icon from "ds/components/Icon";
import { Minus, Plus } from "components/icons/generated";

import styles from "./styles.module.css";

type DiffCountsProps = {
  additions: number;
  deletions: number;
};

const DiffCounts = ({ additions, deletions }: DiffCountsProps) => {
  if (additions === 0 && deletions === 0) return null;

  return (
    <Box direction="row" gap="medium" align="center">
      {additions > 0 && (
        <Typography variant="p-t8" tag="span" className={styles.additions}>
          <Icon src={Plus} /> {additions}
        </Typography>
      )}
      {deletions > 0 && (
        <Typography variant="p-t8" tag="span" className={styles.deletions}>
          <Icon src={Minus} /> {deletions}
        </Typography>
      )}
    </Box>
  );
};

export default DiffCounts;
